import {
  PolicyContainer,
  PolicyTitle,
  PolicyVersion,
  PolicyText,
  PolicySectionTitle,
  PolicyArticleTitle,
  PolicyHyphenList,
} from "styles/PolicyCommon";
import { useEffect } from "react";

const OperationJa = () => {
  useEffect(() => {
    document.documentElement.lang = "ja";
    document.title = "pregnancy&baby";
    return () => {
      document.documentElement.lang = "en";
      document.title = "pregnancy&baby";
    };
  }, []);

  return (
    <PolicyContainer>
      <h1 className="hide">pregnancy&amp;baby</h1>
      <PolicyTitle>pregnancy&baby コミュニティガイドライン</PolicyTitle>
      <PolicyVersion>
        施行日：2026年9月21日
        <br />
        最終改定日：2026年8月25日
      </PolicyVersion>

      <PolicyText>
        本コミュニティガイドライン（以下「本ガイドライン」といいます）は、
        Connecti Co., Ltd.（以下「当社」といいます）が運営する{" "}
        <strong>pregnancy&baby</strong>{" "}
        において提供するコミュニティ機能をご利用いただく際のルールおよび運営基準を定めるものです。
      </PolicyText>
      <PolicyText>
        pregnancy&babyのコミュニティは、妊活、不妊治療、妊娠、出産、育児をはじめとするさまざまなテーマについて、ユーザー同士が経験や悩み、質問、情報などを共有できる場です。
      </PolicyText>
      <PolicyText>
        当社は、pregnancy&babyが、ユーザーの皆さまが安心して交流し、お互いを尊重しながら支え合えるコミュニティとなるよう努めています。コミュニティ機能をご利用になる前に、本ガイドラインをご確認のうえ、遵守してください。
      </PolicyText>
      <PolicyText>
        本ガイドラインは、<strong>pregnancy&baby利用規約</strong>
        を補完するものです。関連法令、利用規約または本ガイドラインに違反する行為が確認された場合、当社は投稿の制限・削除、コミュニティ機能の利用制限など、必要な措置を講じることがあります。
      </PolicyText>
      <PolicyText>
        当社は、安全で健全なコミュニティ環境を維持するため、必要に応じて本ガイドラインを変更することがあります。重要な変更については、利用規約および関連法令に従い、事前にお知らせします。
      </PolicyText>

      <PolicySectionTitle>1. プロフィールについて</PolicySectionTitle>
      <PolicyText>
        ニックネームやプロフィール画像は、コミュニティ内で他のユーザーがあなたを認識するための情報です。
      </PolicyText>
      <PolicyText>
        ご自身を適切に表すプロフィール情報を設定してください。
      </PolicyText>
      <PolicyText>
        以下に該当するプロフィールについては、利用を制限したり、変更をお願いしたりする場合があります。
      </PolicyText>
      <PolicyHyphenList>
        <li>不適切、不快、わいせつ、または違法な内容を含むもの </li>
        <li>
          他の個人または団体の名称、商標、ロゴ、画像その他の権利で保護された素材を無断で使用するもの{" "}
        </li>
        <li>
          他人、企業、団体、pregnancy&babyのスタッフまたは運営者等になりすますもの{" "}
        </li>
        <li>その他、他のユーザーに誤解や混乱を与えるおそれがあるもの</li>
      </PolicyHyphenList>

      <PolicySectionTitle>2. コミュニティへの投稿について</PolicySectionTitle>
      <PolicyText>
        pregnancy&babyのコミュニティに投稿した内容は、他のユーザーが閲覧できる場合があります。
      </PolicyText>
      <PolicyText>
        投稿する前に、ご自身または他人の個人情報や、公開を希望しないセンシティブな情報が含まれていないか、十分にご確認ください。
      </PolicyText>
      <PolicyText>
        投稿、コメント、プロフィール情報、画像その他のコンテンツは、本ガイドラインおよびpregnancy&baby利用規約を遵守する必要があります。
      </PolicyText>

      <PolicySectionTitle>3. 不適切な投稿を見つけた場合</PolicySectionTitle>
      <PolicyText>
        スパム、無断広告、誹謗中傷、嫌がらせ、暴言など、本ガイドラインに違反していると思われる投稿やコメントを見つけた場合は、サービス内の違反報告機能をご利用ください。
      </PolicyText>
      <PolicyText>
        皆さまからの報告は、より安全で健全なコミュニティ環境の維持に役立てられます。
      </PolicyText>
      <PolicyText>
        当社は、報告された内容を確認し、本ガイドライン、利用規約および関連法令に基づき、必要に応じて適切な措置を講じます。
      </PolicyText>
      <PolicyText>
        ※
        日本の主要コミュニティでも、利用者からの違反報告をもとに投稿を確認・削除する仕組みが一般的に採用されています。
      </PolicyText>

      <PolicySectionTitle>4. 禁止されている投稿・行為</PolicySectionTitle>
      <PolicyText>
        pregnancy&babyのコミュニティでは、以下に該当する投稿・行為を禁止します。
      </PolicyText>

      <PolicyArticleTitle>4.1 わいせつ・性的なコンテンツ</PolicyArticleTitle>
      <PolicyText>以下の内容を投稿しないでください。</PolicyText>
      <PolicyHyphenList>
        <li>過度に露骨な性的表現、わいせつな画像または文章 </li>
        <li>売春、違法な性的サービスを宣伝、勧誘または仲介する内容 </li>
        <li>
          他人に性的な羞恥心や不快感を与えたり、性的な嫌がらせを目的とした内容{" "}
        </li>
        <li>性的搾取その他の違法な性的コンテンツ</li>
      </PolicyHyphenList>

      <PolicyArticleTitle>4.2 違法行為・違法な取引</PolicyArticleTitle>
      <PolicyText>以下の行為は禁止します。</PolicyText>
      <PolicyHyphenList>
        <li>違法な賭博・ギャンブルを宣伝または利用へ誘導する行為 </li>
        <li>違法な商品・サービスを販売、購入、交換または勧誘する行為 </li>
        <li>
          関連法令によりオンラインでの販売が禁止されている商品を販売または宣伝する行為{" "}
        </li>
        <li>
          違法行為を助長、支援または容易にすることを目的とした情報を提供する行為
        </li>
      </PolicyHyphenList>

      <PolicyArticleTitle>4.3 有害・不快なコンテンツ</PolicyArticleTitle>
      <PolicyText>以下の内容を投稿しないでください。</PolicyText>
      <PolicyHyphenList>
        <li>
          著しく損傷した身体や露骨な死亡場面など、過度に残虐または不快感を与える画像・内容{" "}
        </li>
        <li>性的搾取に関する、またはこれを助長する内容 </li>
        <li>性的搾取を目的として他人を脅迫、勧誘または誘導する行為 </li>
        <li>暴力を助長または賛美する内容 </li>
        <li>
          国籍、出身地域、人種、外見、障がい、疾病、性別、性自認、性的指向その他個人の属性を理由として、差別、憎悪または偏見を助長する内容{" "}
        </li>
        <li>自殺または集団自殺を助長、支援または勧誘する内容</li>
      </PolicyHyphenList>

      <PolicyArticleTitle>4.4 広告・宣伝・勧誘行為</PolicyArticleTitle>
      <PolicyText>
        当社の許可を得ていない商業目的の広告、宣伝、勧誘、スパム行為は、制限または削除の対象となる場合があります。
      </PolicyText>
      <PolicyText>以下のような内容が含まれます。</PolicyText>
      <PolicyHyphenList>
        <li>同一または類似する広告・宣伝内容を繰り返し投稿する行為 </li>
        <li>主に商品やサービスの宣伝を目的とする投稿 </li>
        <li>ユーザーを外部の商業活動や取引へ誘導する投稿 </li>
        <li>その他、コミュニティを営業・集客目的で利用する行為</li>
      </PolicyHyphenList>
      <PolicyText>
        当社は、コミュニティ内の投稿やユーザー同士のやり取りをきっかけとして、ユーザー間で自主的に行われた取引には関与せず、その安全性や取引内容を保証するものではありません。
      </PolicyText>
      <PolicyText>
        不審な広告、宣伝または勧誘行為を見つけた場合は、サービス内の違反報告機能をご利用ください。
      </PolicyText>

      <PolicyArticleTitle>
        4.5 誹謗中傷・嫌がらせ・暴言・なりすまし
      </PolicyArticleTitle>
      <PolicyText>以下の行為は禁止します。</PolicyText>
      <PolicyHyphenList>
        <li>他人を繰り返し侮辱、脅迫、攻撃または嫌がらせする行為 </li>
        <li>
          特定のユーザーに対して、過度に侮辱的、攻撃的または人格を否定するような表現を使用する行為{" "}
        </li>
        <li>
          pregnancy&baby、当社、当社の役職員、運営者または他人になりすます行為{" "}
        </li>
        <li>
          他のユーザーを欺いたり、不当な利益を得たりする目的で、身元や立場を偽る行為{" "}
        </li>
        <li>
          他の個人または団体に損害を与えるおそれのある虚偽または誤解を招く情報を故意に拡散する行為{" "}
        </li>
        <li>
          実際のニュースや報道であると誤認させるような虚偽の内容を投稿する行為
        </li>
      </PolicyHyphenList>

      <PolicyArticleTitle>
        4.6 悪意のあるプログラム・サービスへの妨害
      </PolicyArticleTitle>
      <PolicyText>以下の行為は禁止します。</PolicyText>
      <PolicyHyphenList>
        <li>
          ウイルス、マルウェア、悪意のあるコードなど、端末やシステムを損傷または妨害することを目的としたプログラム等を投稿、配布またはリンクする行為{" "}
        </li>
        <li>pregnancy&babyの正常な運営を妨害する行為 </li>
        <li>サービスの脆弱性を悪用する行為 </li>
        <li>
          自動化された手段または許可されていない方法を利用して、広告、宣伝、友だち申請、リアクションの要求その他類似する内容を大量に配信する行為
        </li>
      </PolicyHyphenList>

      <PolicyArticleTitle>4.7 知的財産権の侵害</PolicyArticleTitle>
      <PolicyText>他人の知的財産権を尊重してください。</PolicyText>
      <PolicyText>以下の行為は禁止します。</PolicyText>
      <PolicyHyphenList>
        <li>
          他人の著作物、商標、デザイン、画像その他権利で保護された素材を無断で使用する行為{" "}
        </li>
        <li>
          放送、音楽、映画、アニメーション、写真、画像、記事、投稿その他の著作物を適切な許可なく共有する行為{" "}
        </li>
        <li>著作物を違法に入手または利用するための方法・情報を提供する行為 </li>
        <li>
          他のpregnancy&babyユーザーの投稿、写真または画像を、権利を侵害する形で無断転載・複製する行為
        </li>
      </PolicyHyphenList>

      <PolicyArticleTitle>
        4.8 個人情報の掲載・外部サービスへの誘導
      </PolicyArticleTitle>
      <PolicyText>
        ユーザーのプライバシーと安全を守るため、以下の行為は禁止します。
      </PolicyText>
      <PolicyHyphenList>
        <li>投稿やコメントを通じて他のユーザーの個人情報を求める行為 </li>
        <li>
          ご自身または他人の個人情報を公開し、プライバシー侵害や安全上のリスクを生じさせる行為{" "}
        </li>
        <li>
          外部SNS、メッセージアプリその他の外部サービスでのやり取りへ、繰り返しまたは不適切に誘導する行為
        </li>
      </PolicyHyphenList>
      <PolicyText>
        コミュニティに情報を投稿する際は、他のユーザーがその内容を閲覧できる可能性があることに十分ご注意ください。
      </PolicyText>

      <PolicyArticleTitle>
        4.9 スパム・荒らし行為・その他の迷惑行為
      </PolicyArticleTitle>
      <PolicyText>以下の行為は禁止します。</PolicyText>
      <PolicyHyphenList>
        <li>同一または実質的に同じ内容を繰り返し投稿する行為 </li>
        <li>サービス内の複数の場所に同一・類似の内容を繰り返し投稿する行為 </li>
        <li>サービスの機能を不正に操作または悪用する行為 </li>
        <li>他のユーザーによる正常なサービス利用を故意に妨害する行為 </li>
        <li>その他、コミュニティの正常な運営を著しく妨げる行為</li>
      </PolicyHyphenList>
      <PolicyText>
        本ガイドラインに具体的に記載されていない行為であっても、サービスの安全性、健全性または正常な運営を明らかに損なう行為や、他のユーザーによるサービスの利用を著しく妨害する行為については、制限の対象となる場合があります。
      </PolicyText>

      <PolicySectionTitle>5. 投稿・コンテンツの管理</PolicySectionTitle>
      <PolicyText>
        関連法令、pregnancy&baby利用規約または本ガイドラインに違反するコンテンツについて、当社は以下の措置を講じることがあります。
      </PolicyText>
      <PolicyHyphenList>
        <li>投稿・コンテンツの表示範囲の制限 </li>
        <li>投稿・コンテンツの一時的な非表示 </li>
        <li>投稿・コンテンツの削除 </li>
        <li>投稿またはコメント機能の利用制限 </li>
        <li>一部のコミュニティ機能の利用制限 </li>
        <li>
          違反の継続または被害の拡大を防止するために合理的に必要なその他の措置{" "}
        </li>
      </PolicyHyphenList>
      <PolicyText>
        当社は、ユーザーが投稿するすべてのコンテンツを事前に確認する義務を負うものではありません。
      </PolicyText>
      <PolicyText>
        特定のコンテンツがサービス上に表示されていることは、当社が当該コンテンツを承認、推奨または保証したことや、その内容の正確性を確認したことを意味するものではありません。
      </PolicyText>

      <PolicySectionTitle>
        6. アカウントおよびサービスの利用制限
      </PolicySectionTitle>
      <PolicyText>
        ユーザーが関連法令、利用規約または本ガイドラインに違反した場合、当社は一部の機能またはサービスの利用を制限することがあります。
      </PolicyText>
      <PolicyText>
        違反の内容、重大性、回数などに応じて、一時的または恒久的な利用制限を行う場合があります。
      </PolicyText>
      <PolicyText>当社が講じる措置には、以下が含まれます。</PolicyText>
      <PolicyHyphenList>
        <li>警告 </li>
        <li>投稿・コンテンツの表示制限 </li>
        <li>投稿・コンテンツの削除 </li>
        <li>投稿またはコメント機能の一時的な利用制限 </li>
        <li>コミュニティ機能の利用制限 </li>
        <li>アカウントの一時停止 </li>
        <li>重大な違反の場合におけるアカウントの恒久的な利用制限</li>
      </PolicyHyphenList>
      <PolicyText>
        重大な違法行為、性的搾取、違法な賭博、重大な安全上のリスク、サービスに対する悪意のある攻撃その他重大な違反については、段階的な制限を行うことなく、直ちに必要な措置を講じる場合があります。
      </PolicyText>
      <PolicyText>
        また、異常なアカウント活動、不正アクセスの試み、自動化された不正利用その他ユーザーまたはサービスの安全を脅かす可能性のある活動が検知された場合、当社は合理的に必要な保護措置を講じることがあります。
      </PolicyText>

      <PolicySectionTitle>7. 異議申立て</PolicySectionTitle>
      <PolicyText>
        ご自身の投稿・コンテンツまたはアカウントが誤って制限されたと考える場合は、pregnancy&babyカスタマーサポートにお問い合わせいただき、再確認を依頼することができます。
      </PolicyText>
      <PolicyText>
        当社は、本ガイドライン、利用規約および関連法令に基づき、当該申立ての内容を確認します。
      </PolicyText>
      <PolicyText>
        <strong>カスタマーサポート</strong>：after10month@connect-i.co.kr
      </PolicyText>

      <PolicySectionTitle>8. 利用規約との関係</PolicySectionTitle>
      <PolicyText>
        本ガイドラインは、pregnancy&babyの利用に適用される運営ルールの一部であり、
        <strong>pregnancy&baby利用規約</strong>と併せて適用されます。
      </PolicyText>
      <PolicyText>
        本ガイドラインに定めのない事項については、pregnancy&baby利用規約、関連法令および当社が別途定める適用可能なポリシーに従って取り扱います。
      </PolicyText>
    </PolicyContainer>
  );
};

export default OperationJa;
